import { render } from "./PDFBlock.vue?vue&type=template&id=25424f9b&scoped=true&ts=true"
import script from "./PDFBlock.vue?vue&type=script&lang=ts"
export * from "./PDFBlock.vue?vue&type=script&lang=ts"

import "./PDFBlock.vue?vue&type=style&index=0&id=25424f9b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25424f9b"]])

export default __exports__